<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_752')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_753')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.carrier" :placeholder="$t('scope.text_754')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_745')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.trace_no" :placeholder="$t('scope.text_755')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'InvoicePostDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        carrier: [
          'carrier',
          {
            rules: [
              { required: true, message: this.$t('scope.text_754') },
            ],
          },
        ],
        trace_no: [
          'trace_no',
          {
            rules: [
              { required: true, message: this.$t('scope.text_755') },
            ],
          },
        ],
      },
    }
  },
  methods: {
    doSend (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'send',
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doSend(values)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
